// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__3l-z7","icon":"style_icon__3i_4O","content":"style_content__3yBpO"};